module.exports = __webpack_public_path__ + "img/tripdaze-hero.b7184254.jpg";